const initiativeListButtons = document.getElementsByClassName('initiative-list-button');


/**
 *
 *
 *
 */
const init = function() {

	if ( initiativeListButtons ) {
		Array.prototype.forEach.call(initiativeListButtons, function(button){
			setupButtonBehavior(button);
		});
	}

};


/**
 *
 *
 *
 */
const setupButtonBehavior = function( button ) {

	button.addEventListener( 'click', function() {

		const listRef = this.getAttribute('aria-controls');
		const list = document.getElementById(listRef);
		const listItems = list.children;

		for ( let i = 0; i < listItems.length; i++ ) {
			let liElement = listItems[i];
			liElement.classList.add('is-entering');

			setTimeout( () => {
				liElement.classList.add('is-visible');
			}, 10 );

		}

		setTimeout( () => {
			jumpToAnchor( listRef+'_item_6' );
		}, 12 );

		this.style.display = 'none';

	} );

}


/**
 *
 *
 *
 */
const jumpToAnchor = function(h){
	const url = location.href;
	location.href = "#"+h;
	history.replaceState(null,null,url);
}


const api = {
	init: init
};

export default api;